import { render, staticRenderFns } from "./OrderProcessing.vue?vue&type=template&id=3af5d69f"
import script from "./OrderProcessing.vue?vue&type=script&lang=js"
export * from "./OrderProcessing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports